import { IconName } from "@blueprintjs/core";
import { match } from "ts-pattern";

import {
  ValidFileTypeIO,
  ValidFileTypeT,
} from "ui-io/assets-io/valid-file-type-io";

const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

/**
 * Returns the icon name for a particular file content type. To get a valid file
 * type, you can first call `getValidContentType`.
 */
const getIconForContentType = (validFileType: ValidFileTypeT | undefined) => {
  const icon = match(validFileType)
    .with(
      "image/bmp",
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/tiff",
      "image/webp",
      () => "media"
    )
    .with("application/pdf", () => "document")
    .with(
      "application/json",
      "text/csv",
      "text/plain",
      "text/rtf",
      "text/tab-separated-values",
      () => "code"
    )
    .with("application/zip", () => "archive")
    .with(undefined, () => "cube")
    .otherwise(() => "unknown") as IconName;

  return icon;
};

const getValidContentType = (contentType: string | undefined) => {
  return ValidFileTypeIO.is(contentType) ? contentType : undefined;
};

export { formatBytes, getIconForContentType, getValidContentType };
